// Module
var code = "<div class=\"error-page\" layout-padding> <div layout=\"column\" layout-align=\"space-between center\" layout-padding> <h3 class=\"md-headline text-center\" layout-padding> We are having some trouble finding the page you are looking for... </h3> </div> </div> ";
// Exports
module.exports = code;